import React, { Component } from 'react';
import Article from './Article';
import css from './About.module.scss';

import ImgA1 from './assets/a1.jpg';
import ImgA2 from './assets/a2.jpg';
import ImgA3 from './assets/a3.jpg';
import ImgA4 from './assets/a4.jpg';
import ImgA5 from './assets/a5.jpg';
import ImgA6 from './assets/a6.jpg';
import ImgA7 from './assets/a7.jpg';

export default class About extends Component {

  render () {
      return (
        <div className={css.content}>
          <h2>Senior product designer<br />
          Product manager<br />
          Amateur chef<br />
          History lover</h2>
          <img src={ImgA1} alt='On vacation in Denmark' />
          <div className={css.text}>
            <p>Senior product designer & product manager with over ten years experience in the industry. I studied Business Administration at <a href="https://www.calpoly.edu/" target="_blank" rel="noopener noreferrer">CSU Cal Poly</a> and New Media Design at <a href="https://www.academyart.edu/" target="_blank" rel="noopener noreferrer">AAU</a>. I then worked at self-funded tech incubator Bebo until it was acquired by Twitch. While in San Francisco, I co-founded a non-profit, ShelterTech, to addres the technology needs of people experiencing homelessness.</p>
            <p>My nickname at Bebo was “The Mailman” because I deliver every day except Sunday. I believe everything is worth doing with 100% focus and passion. Every task is an opportunity to improve—a chance to elevate work to a craft.</p>
          </div>
          <div className={css.skills}>
            <p className={css.caption}>Core Skills</p>
            <ul className={css.skillsList}>
              <li>
                <header className={css.skillsListHeader}>
                  Product Design
                </header>
                <ul>
                  <li>Mobile Apps</li>
                  <li>Websites</li>
                  <li>Interface Design</li>
                  <li>Interaction Design</li>
                  <li>UX Research</li>
                </ul>
              </li>
              <li>
                <header className={css.skillsListHeader}>
                  Product Management
                </header>
                <ul>
                  <li>Product Strategy & Leadership</li>
                  <li>Problem Specification</li>
                  <li>User Stories</li>
                  <li>Feature Prioritisation</li>
                  <li>Roadmap Development</li>
                </ul>
              </li>
              <li>
                <header className={css.skillsListHeader}>
                  Marketing
                </header>
                <ul>
                  <li>Graphics</li>
                  <li>Photography</li>
                  <li>Video & Motion Graphics</li>
                  <li>Copywriting</li>
                  <li>Slide Decks</li>
                </ul>
              </li>
              <li>
                <header className={css.skillsListHeader}>
                  Visual Identity
                </header>
                <ul>
                  <li>Logo & Branding</li>
                  <li>Typography</li>
                  <li>Iconography</li>
                  <li>Stationery</li>
                  <li>Apparel</li>
                </ul>
              </li>
              <li>
                <header className={css.skillsListHeader}>
                  Development
                </header>
                <ul>
                  <li>React</li>
                  <li>HTML</li>
                  <li>SCSS</li>
                </ul>
              </li>
              <li>
                <header className={css.skillsListHeader}>
                  Consultation
                </header>
                <ul>
                  <li>Reports</li>
                  <li>Pitches</li>
                  <li>Demos</li>
                  <li>Workshops</li>
                  <li>Trainings</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className={css.text}>
            <span className={css.caption}>Workspace</span>
            <img src={ImgA2} alt='Workspace' />
          </div>

          <div className={css.text}>
            <p>Outside of work you can find me cooking, traveling, reading New Philosopher magazine, taking photos of my dog and cat, appearing on <a href="https://www.human.nl/therightthing.html" target="_blank" rel="noopener noreferrer">Dutch television shows</a>, and playing video games. I also enjoy scuba diving, drum & bass, and humid summer nights.</p>
          </div>
          <img src={ImgA3} alt='Photos' />

          <ul className={css.articles}>
            <header className={css.articlesHeader}>
              Recent Articles
            </header>
            <Article
              title={'The cost of housing is tearing our society apart'}
              description={'World Economic Forum Agenda'}
              img={ImgA4}
              link={'https://www.weforum.org/agenda/2019/01/why-housing-appreciation-is-killing-housing/'}
            />
            <Article
              title={'Building Technology and Community to Address Homelessness in San Francisco'}
              description={'Open Referral'}
              img={ImgA5}
              link={'https://openreferral.org/building-both-technology-and-community-to-address-homelessness-in-san-francisco/'}
            />
            <Article
              title={'Does the world need a new Socrates?'}
              description={'Personal Blog'}
              img={ImgA6}
              link={'https://medium.com/@derekfidler/what-the-world-needs-is-a-new-socrates-29a79ef8592'}
            />
            <Article
              title={'How did I end up here?'}
              description={'Personal Blog'}
              img={ImgA7}
              link={'https://medium.com/@derekfidler/taking-conversation-off-the-screen-d0c3fb826378'}
            />
          </ul>
        </div>
      )
   }
}
